// extracted by mini-css-extract-plugin
export default {"navigationContainer":"Navigation_navigationContainer__VsgAZ","iconItems":"Navigation_iconItems__Dtw1f"};